import { SVGProps, Ref, forwardRef } from 'react';

export const LocationOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m11.977 12.024 1.588 5.674c.312 1.114.549 1.953.758 2.583.29-.597.635-1.398 1.091-2.461l3.217-7.506c1.185-2.765 1.99-4.657 2.364-6.026.183-.675.218-1.077.2-1.303-.012-.143-.037-.168-.18-.18-.226-.018-.628.017-1.303.2-1.37.373-3.261 1.18-6.026 2.364L6.18 8.586c-1.063.456-1.864.8-2.461 1.09.63.21 1.469.447 2.583.759zm1-8.31L5.47 6.93C2.448 8.226.937 8.873 1.002 9.856s1.648 1.427 4.815 2.313l4.698 1.316 1.316 4.698c.886 3.167 1.33 4.75 2.313 4.815s1.63-1.446 2.926-4.469l3.216-7.506c2.323-5.418 3.484-8.128 2.151-9.46-1.332-1.333-4.042-.172-9.46 2.15"
                fill="currentColor"
            />
        </g>
    </svg>
));
LocationOutlinedSize24Glyph.displayName = 'LocationOutlinedSize24Glyph';
